import ApplicationAdapter from "./application";

export default class DnsDomainAdapter extends ApplicationAdapter {
  urlForFindRecord(id) {
    return `${this.apiBaseUri}/domain/details?domainname=${id}`;
  }

  urlForCreateRecord(_, snapshot) {
    return `${this.apiBaseUri}/domain/add?context=${snapshot.belongsTo("project").id}`;
  }

  urlForUpdateRecord(id) {
    return `${this.apiBaseUri}/domain/edit?domainname=${id}`;
  }

  urlForDeleteRecord(id) {
    return `${this.apiBaseUri}/domain/delete?domainname=${id}`;
  }
}
